import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import Layout from "../components/layout";
import loadable from "@loadable/component";
import { ProductsContextProvider } from "../contexts/ProductsContext";

const ProductGrid = loadable(() => import("../components/product-grid/product-grid"));

export default ({ children, pageContext }) => {
  const { pageName, lines, navigation, language, type, grid} = pageContext;
  const data = useStaticQuery(graphql`
    query MyQuery {
      allLocale {
        edges {
          node {
            data
            language
          }
        }
      }
    }
  `);

  let filteredData = data.allLocale.edges.filter((trans, i) => {
    return trans.node.language === language;
  });
  // Object.keys(filteredData).forEach(key => {
  //   console.log(language, filteredData[key].language)
  //   if (filteredData[key].language !==language) delete filteredData[key];
  // });
  let dataTrans = JSON.parse(filteredData[0].node.data);
  const products = dataTrans.productList;
  return (
    <Layout
      lines={lines}
      page={pageName}
      navigation={navigation}
      language={language}
      data={dataTrans}
      type={type}
    >
      <ProductsContextProvider>
        {grid && <ProductGrid language={language} products={products} cta={dataTrans['drag_hint']} />}
        {children}
      </ProductsContextProvider>
    </Layout>
  );
};
